import { useEffect } from 'react';
import { useWardStore } from '@/stores/wardStore';

export function useSelectionHistory() {
  const { undoSelection, redoSelection, canUndo, canRedo } = useWardStore();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Check for Ctrl/Cmd + Z (Undo)
      if ((event.ctrlKey || event.metaKey) && event.key === 'z' && !event.shiftKey) {
        event.preventDefault();
        if (canUndo()) {
          undoSelection();
        }
      }
      
      // Check for Ctrl/Cmd + Y or Ctrl/Cmd + Shift + Z (Redo)
      if (
        ((event.ctrlKey || event.metaKey) && event.key === 'y') ||
        ((event.ctrlKey || event.metaKey) && event.key === 'z' && event.shiftKey)
      ) {
        event.preventDefault();
        if (canRedo()) {
          redoSelection();
        }
      }
    };

    // Add event listener
    window.addEventListener('keydown', handleKeyDown);

    // Cleanup
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [undoSelection, redoSelection, canUndo, canRedo]);

  return {
    canUndo: canUndo(),
    canRedo: canRedo(),
    undoSelection,
    redoSelection,
  };
}